import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import RankingModal from "../Components/Modals/RankingComponents/RankingModal";
import MyTablesModal from "../Components/Modals/MyTablesModal";
import VipTablesModal from "../Components/Modals/VipTablesModal";
import BecomeVipModal from "../Components/Modals/BecomeVipModal";
import { useSelector } from "react-redux";

type Props = NativeStackScreenProps<RootStackParamList, "VipTables">;

const VipTablesScreen: React.FC<Props> = ({ navigation }) => {
  const auth = useSelector((s: any) => s.auth);
  const isVip = auth?.user?.isVip || false;

  return (
    <>
      {isVip ? (
        <VipTablesModal onClose={() => navigation.goBack()} />
      ) : (
        <BecomeVipModal onClose={() => navigation.goBack()} />
      )}
    </>
  );
};

export default VipTablesScreen;
